import {Injectable} from '@angular/core';
import {ActiveToast, ToastrService} from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class CustomToastrService {

  constructor(private readonly toastr: ToastrService) {
  }

  warning(
    message?: string,
    title?: string,
    override?: Partial<any>
  ): ActiveToast<any> {
    override = {
      easing: "fly-right",
      progressBar: true,
      progressAnimation: "increasing",
      autoDismiss: true,
      timeOut: 3000,
      ...override,
    };
    return this.toastr.warning(message, title, override);
  }

  error(
    message?: string,
    title?: string,
    override?: Partial<any>
  ): ActiveToast<any> {
    override = {
      easing: "fly-right",
      progressBar: true,
      progressAnimation: "increasing",
      autoDismiss: true,
      timeOut: 3000,
      ...override,
    };
    return this.toastr.error(message, title, override);
  }

  success(
    message?: string,
    title?: string,
    override?: Partial<any>
  ): ActiveToast<any> {
    override = {
      easing: "fly-right",
      progressBar: true,
      progressAnimation: "increasing",
      autoDismiss: true,
      timeOut: 3000,
      ...override,
    };
    return this.toastr.success(message, title, override);
  }

  info(
    message?: string,
    title?: string,
    override?: Partial<any>
  ): ActiveToast<any> {
    override = {
      easing: "fly-right",
      progressBar: true,
      progressAnimation: "increasing",
      autoDismiss: true,
      timeOut: 3000,
      ...override,
    };
    return this.toastr.info(message, title, override);
  }
}
